<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn color="info" dark v-on="on" small>Actions</v-btn>
    </template>
    <v-list>
      <v-list-tile @click="createEntry(suggestion, false)">
        <v-list-tile-title>
          <v-icon>add</v-icon>
          File {{ $route.params.objectId }}
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="createEntry(suggestion, true)" v-if="showCopy">
        <v-list-tile-title>
          <v-icon>add</v-icon>
          File {{ $route.params.objectId }} &amp; related {{ file.relatedId }}
        </v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="navigate(suggestion)">
        <v-list-tile-title>
          <v-icon>launch</v-icon>View record
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "SuggestionLink",
  props: ["file", "suggestion", "showCopy"],
  methods: {
    navigate(item) {
      // console.log(item.articleId);
      this.$router.push({
        name: "entity",
        params: {
          id: item.id
        }
      });
    },
    async createEntry(suggestion, related) {
      if (confirm("Are you sure?")) {
        this.createEntryAsync(this.$route.params.objectId, suggestion.id);
        if (related) {
          this.createEntryAsync(this.file.relatedId, suggestion.id);
        }
        this.$router.push({
          name: "file",
          params: {
            id: this.$route.params.objectId
          }
        });
      }
    },
    async createEntryAsync(fileid, entityid) {
      await nbmlaw.post(`/cors/admin/file/files/${fileid}/addressbooks`, null, {
        params: { entityid }
      });
    }
  }
};
</script>
